export default {
  namespaced: true,
  state: {
    authorizations: {}, 
  },
  mutations: {
    setAuthorizations(state, groupedAuthorizations) {
      state.authorizations = groupedAuthorizations;
    },
  },
  actions: {
    loadAuthorizationsFromUser({ commit, rootState }) {
      const user = rootState.authentication.user;

      if (!user || !user.permissions) return;

      const grouped = {};

      user.permissions.forEach((perm) => {
        const unitId = perm.unit?.id || "global";

        if (!grouped[unitId]) grouped[unitId] = [];

        grouped[unitId].push({
          permissionKey: perm.permissionKey,
          can: perm.can,
        });
      });

      commit("setAuthorizations", grouped);
    },
  },
};

